var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4987 2.33337C7.82086 2.33337 8.08203 2.59454 8.08203 2.91671V11.0834C8.08203 11.4055 7.82086 11.6667 7.4987 11.6667C7.17653 11.6667 6.91536 11.4055 6.91536 11.0834V2.91671C6.91536 2.59454 7.17653 2.33337 7.4987 2.33337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83203 7.00004C2.83203 6.67788 3.0932 6.41671 3.41536 6.41671H11.582C11.9042 6.41671 12.1654 6.67788 12.1654 7.00004C12.1654 7.32221 11.9042 7.58337 11.582 7.58337H3.41536C3.0932 7.58337 2.83203 7.32221 2.83203 7.00004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/CreateIcon.53f8b4e2224261d84e2793c5fe2fa7b1.svg";
export { ForwardRef as ReactComponent };